import { jsx as f } from "@emotion/react/jsx-runtime";
import { useState as S, useRef as g, useEffect as y } from "react";
import { StyledText as R } from "./Text.styled.js";
import { recursivelyGetChildrenString as v } from "../../utils/recursivelyGetChildrenString.js";
import { Tooltip as C } from "../Tooltip/index.js";
const I = ({
  variant: s = "bodyMRegular",
  children: r,
  as: l = "div",
  color: o = "default",
  oneLine: t = !1,
  className: i,
  disabled: a = !1,
  noTooltip: c = !1,
  italic: u = !1,
  underline: m = !1,
  id: n
}) => {
  const [d, p] = S(!1), e = g(null), x = v(r);
  return y(() => {
    if (t && e?.current) {
      const {
        offsetWidth: T,
        scrollWidth: h
      } = e.current;
      p(T < h);
    }
  }, [t]), /* @__PURE__ */ f(C, { text: !c && t && d ? x : "", children: /* @__PURE__ */ f(R, { ref: e, as: l, color: o, variant: s, oneLine: t, className: i, disabled: a, italic: u, underline: m, id: n, children: r }) });
};
export {
  I as Text
};
